import { useEffect, useState } from 'react';

const useIsMobileScreen = (breakpoint = 768) => {
  const [isMobileScreen, setIsMobileScreen] = useState<boolean>(false);

  useEffect(() => {
    function onResize() {
      const width = window.innerWidth;
      setIsMobileScreen(width < breakpoint);
    }
    window.addEventListener('resize', onResize);

    onResize();

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [breakpoint]);

  return isMobileScreen;
};

export default useIsMobileScreen;
